import { Configuration, PromotionsApi } from '@/api';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetPromotionQuery = (promotionId?: string) => {
  const queryClient = useQueryClient();

  const promotionsApi = new PromotionsApi(new Configuration(useAuth));

  const {
    isLoading,
    data: promotion,
    error,
  } = useQuery({
    queryKey: ['promotion', promotionId],
    queryFn: () => {
      return promotionId ? promotionsApi.getPromotion(promotionId) : null;
    },
    enabled: !!promotionId,
  });

  const invalidateQuery = async (alsoInvalidateList = false) => {
    await queryClient.invalidateQueries({ queryKey: ['promotion', promotionId] });

    if (alsoInvalidateList) {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'promotions',
      });
    }
  };

  return {
    promotion,
    isLoading,
    error,
    invalidateQuery,
  };
};

export default useGetPromotionQuery;
